import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

/**
 * Spec 230 — label above, always visible; helper text rendered from the
 * start where a format is required, not only on error.
 *
 * The input is a real `<input>` with the ref forwarded — a `Field` that
 * swallows the element a caller (or Playwright) needs to reach directly
 * would repeat Global Constraint 1's sibling risk.
 */
export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  help?: string;
}

export const Field = forwardRef<HTMLInputElement, FieldProps>(function Field(
  { label, help, id, className, ...rest },
  ref,
) {
  const inputId = id ?? `field-${label.toLowerCase().replace(/\s+/g, '-')}`;
  const helpId = help ? `${inputId}-help` : undefined;
  return (
    <div className="hub-field">
      <label htmlFor={inputId} className="hub-field__label">
        {label}
      </label>
      <input
        ref={ref}
        id={inputId}
        className={['hub-input', className ?? ''].filter(Boolean).join(' ')}
        aria-describedby={helpId}
        {...rest}
      />
      {help && (
        <p id={helpId} className="hub-field__help">
          {help}
        </p>
      )}
    </div>
  );
});
